import React from 'react';
import PropTypes from 'prop-types';
import classes from './ScheduledContentA.module.scss';

const ScheduledContentA = (props) => {
  const {
    heading,
    content,
  } = props;

  return (
    <div className={classes.container}>
      {heading && <h2 className={classes.heading}>{heading}</h2>}
      {content && <div
        className={classes.content}
        dangerouslySetInnerHTML={{ __html: content }}
      />}
    </div>
  );
};

ScheduledContentA.propTypes = {
  /**
   * Heading of the component
  */
  heading: PropTypes.string,
  /**
   * Content of the component
  */
  content: PropTypes.string,
};

export default ScheduledContentA;
